export const groupBy = (input, key) => {
  return input.reduce((accumulator, item) => {
    (accumulator[item[key]] = accumulator[item[key]] || []).push(item);
    return accumulator;
  }, {});
};
